import { useQuery } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { getSectionsTypes } from "../services/mapServices";

export function useSectionTypes(mode) {
  const types = useQuery({
    queryKey: ["sectionTypes", mode],
    queryFn: () => getSectionsTypes(mode),
    staleTime: FIVE_MINUTES_IN_MS,
  });

  return {
    sectionTypesOptions: types.data || [],
    isLoadingSectionTypes: types.isLoading,
  };
}
